import * as actionTypes from '../actions/actionTypes';
import { api } from '../../common/api-utils';

// Edit View actions
const getEditViewRequest = () => ({
	type: actionTypes.EDIT_VIEW_REQUEST
});

const getEditViewSuccess = (payload, tab) => ({
	type: actionTypes.EDIT_VIEW_SUCCESS,
	payload,
	tab
});

const getEditViewFailure = (error) => ({
	type: actionTypes.EDIT_VIEW_FAILURE,
	error
});

export const getEditView = (tab, id, view) => async (dispatch) => {
	try {
		dispatch(getEditViewRequest());
		let res = {};
		if (view === '/app/convertlead/Leads/' + id) {
			res = await api.get(`/V8/layout/ConvertLead/Leads/${id}`);
		} else {
			id !== undefined
				? (res = await api.get(`/V8/layout/EditView/${tab}/${id}`))
				: (res = await api.get(`/V8/layout/CreateView/${tab}/1`));
		}


		if (res.ok) {
			dispatch(getEditViewSuccess(res.data, tab));
			return;
		}
		dispatch(getEditViewFailure(res.data.errors ? res.data.errors.detail : null));
	} catch (e) {
		dispatch(getEditViewFailure(e));
	}
};

export const getConvertLeadView = (tab, id) => async (dispatch) => {
	try {
		dispatch(getEditViewRequest());
		let res = {};
		res = await api.get(`/V8/layout/ConvertLead/Leads/1`)
		if (res.ok) {
			dispatch(getEditViewSuccess(res.data, tab));
			return;
		}
		dispatch(getEditViewFailure(res.data.errors ? res.data.errors.detail : null));
	} catch (e) {
		dispatch(getEditViewFailure(e));
	}
};


const submitEditViewRequest = () => ({
	type: actionTypes.SUBMIT_EDIT_VIEW_REQUEST
});

const submitEditViewSuccess = (payload) => ({
	type: actionTypes.SUBMIT_EDIT_VIEW_SUCCESS,
	payload,
});

const submitEditViewFailure = (error) => ({
	type: actionTypes.SUBMIT_EDIT_VIEW_FAILURE,
	error
});
export const submitEditView = (data, id, module, history = [], view = '') => async (dispatch) => {
	//console.log("data",data);
	try {
		dispatch(submitEditViewRequest());
		let res = {};
		// id === undefined
		// 	? (res = await api.post(`/V8/module`, data))
		// 	: (res = await api.patch(`/V8/module`, data));
		//console.log("view", view);
		if (view === '/app/duplicateview/' + module + '/' + id) {
			delete data.data.id;
		}
		data = JSON.stringify(data);

		switch (view) {
			case ("/app/editview/" + module + "/" + id):
				res = await api.patch(`/V8/module`, data);
				break;
			case ("relCreate"):
			case ("QuickCreate"):
			case ("/app/createview/" + module):
			case ("/app/duplicateview/" + module + "/" + id):
				res = await api.post(`/V8/module`, data);
				break;
			case ("/app/convertlead/Leads/" + id):
				res = await api.post(`/V8/layout/setConvertLead/Leads/${id}`, data);
				break;
			default:
				res = {};
				break;
		}
		//console.log("submitttttttt--------1", res)

		if (res.ok) {
			//console.log("submitEdit-=============2", res)

			dispatch(submitEditViewSuccess(res.data));
			//console.log("submitttttttt-------**************-3", res)

			return res.data;
		}
		dispatch(submitEditViewFailure(res.data.errors ? res.data.errors.detail : null));
	} catch (ex) {
		console.log(ex);
		return ex;
	}
};


export const getQuickCreateView = (tab,selectedDate=null,calendarViewType=null) => async (dispatch) => {
	try {
		let res = {};
		let payload = '';
		let payload_calendar_view='';
		if(selectedDate)
		{
			payload =`selected_calendar_date=${selectedDate}`;
		}
		if(calendarViewType)
		{
			payload_calendar_view =`&calendar_view=${calendarViewType}`;
		}
		res = await api.get(`/V8/layout/QuickCreate/${tab}/1?`+payload+payload_calendar_view);
		if (res.ok) {
			return res.data;
		}
	} catch (e) {
		return e;
	}
};

// Edit View actions
const submitInOutboundEmailRequest = () => ({
	type: actionTypes.EDIT_INOUTBOUNDEMAIL_REQUEST
});

const submitInOutboundEmailSuccess = (payload, tab) => ({
	type: actionTypes.EDIT_INOUTBOUNDEMAIL_SUCCESS,
	payload,
	tab
});

const submitInOutboundEmailFailure = (error) => ({
	type: actionTypes.EDIT_INOUTBOUNDEMAIL_FAILURE,
	error
});

export const submitInOutboundEmail = (data,type) => async (dispatch) => {
	try {
		dispatch(submitInOutboundEmailRequest());
		let res = {};
		data = JSON.stringify(data);
		if(type==='inbound'){
			res = await api.post(`/V8/emailsetting/saveinboundemail`, data);
		}else{
			res = await api.post(`/V8/emailsetting/saveoutboundemailaccount`, data);
		}
		
		

		if (res.ok) {
			dispatch(submitInOutboundEmailSuccess(res.data));
			return res.data;
		}
		dispatch(submitInOutboundEmailFailure(res.data.errors ? res.data.errors.detail : null));
	} catch (e) {
		dispatch(submitInOutboundEmailFailure(e));
	}
};
